import { format as dateFnsFormat, fromUnixTime } from "date-fns";

const dateFormats = {
  long: "MMMM d, yyyy hh:mm",
  short: "MMMM dd, yyyy",
  filename: "yyyy-MM-dd-hh-mm-ss",
  local: "PPPp", // local timezone, e.g. in nz March 8th, 2023 at 6:54:02 PM GMT+13
  localTime: "p",
  localDate: "PPP",
  dateInput: "yyyy-LL-dd",
  datetimeInput: "yyyy-LL-dd'T'HH:mm",
  dateAt: "MMM d, yyyy 'at' HH:mm", // e.g. March 8th, 2023 at 15:54
};

/**
 * Formats a date using date-fns with predefined or custom formats.
 *
 * @param date - The Date object to format
 * @param format - Either a predefined format key from dateFormats or a custom format string
 * @returns The formatted date string
 * @throws {Error} If date is undefined, null, or not a Date object
 *
 * @example
 * Using predefined format
 * formatDate(new Date(), "long")
 *
 * @example
 * Using custom format
 * formatDate(new Date(), "yyyy-MM-dd")
 */
export const formatDate = (
  date: Date,
  format: keyof typeof dateFormats = "long",
) => {
  // If date is not added
  if (!date) throw new Error("Date is undefined or null");

  // If date is not a valid date
  if (!(date instanceof Date)) throw new Error("Date arg is not a Date object");

  const result = dateFnsFormat(date, dateFormats[format] || format);

  return result;
};
